export default {"src":"/uk/_next/static/media/pwResetIcon.9f0a55f0.svg","height":60,"width":60,"blurWidth":0,"blurHeight":0};